import { PartCategory } from '@/models/PartCategory'
import { Department } from '@/models/Department'
import { BasePicturesModel } from '@/models/BasePicturesModel'
import { InputParent } from './InputParent'
import { Children } from './Children'
import { InputNearestParent } from './InputNearestParent'


export class Part extends BasePicturesModel {
	static fields () {
		return {
			id: null,
			createdAt: null,
			updatedAt: null,
			price: null,
			priceWithVat: null,
			currency: null,
			currencyHistoryData: null,
			cost: null,
			handover: null,
			costWithVat: null,
			defective: null,
			status: null,
			used: null,
			comment: null,
			sku: null,
			qrComment: null,
			defectComment: null,
			deleteComment: null,
			isSaleAllowed: null,
			orderId: null,
			averagePrice: 0,
			deleted: false,
			department: Department,
			conditionType: null,
			qualityType: null,
			tasks: [],
			height: 0,
			width: 0,
			length: 0,
			weight: 0,
			sellPrice: null,
			sellPriceWithVat: null,
			suggestedPrice: null,
			demand: null,
			suggestedPriceWithVat: null,
			profit: null,
			profitWithVat: null,
			margin: null,
			oemCodes: { id: null, code: null },
			category: PartCategory,
			suggestedLocation: { id: null, name: null },
			location: { id: null, name: null },
			pictures: [],
			inputChildren: [],
			nearestChildren: Children,
			inputParent: InputParent,
			inputNearestParent: InputNearestParent,
			nearestParentId: null,
			groupedSaleId: null,
			ebayItems: [],
			dalysltPart: null,
			kumasoftPart: null,
			allegroPart: [],
			teilehaberPart: null,
			autoteileMarktPart: null,
			parent: false,
			claimPartsPart: null,
			proxyPartsPart: null,
			bildelsbasenPart: null,
			rrrPart: null,
			name: null,
			title: null,
			accountingCode: null,
			customIntegrations: [],
			inputUser: {},
			amazonEnabled: null,
			parentGroupedSale: InputParent,
			vehicleSpecifications: null,
			quantity: null,
			originalPartId: null,
			colorCode: null,
			visible: null,
			isWheel: null,
			vehicleType: null,
			partSpecifications: null,
			positions: [],
			manufacturer: { id: null, name: null },
			model: { id: null, name: null, startDate: null, endDate: null },
			modification: { id: null, name: null, power: null },
			engine: { id: null, name: null },
			vinCode: null,
			color: null,
			bodyType: null,
			driveType: null,
			gearType: null,
			steeringType: null,
			fuelType: null,
			fuelSystem: null,
			coolingType: null,
			engineDisplacement: null,
			year: null,
			mileage: null,
			mileageType: null,
			ean: null,
			platformType: null,
			axleConfiguration: null,
			frontSuspensionType: null,
			rearSuspensionType: null,
			aiResults: null
		}
	}


	static hasMany () {
		return {
			children: Part
		}
	}
}

export function createPart (data) {
	return Object.freeze(new Part(data))
}
